export default {
  init() {
    // JavaScript to be fired on all pages
    $('.hamburger').click(function() {
      $(this).toggleClass('is-active');
      $('.hidden-nav').toggle();
    });

    $('.hidden-nav a').click(function() {
      $('.hamburger').toggleClass('is-active');
      $('.hidden-nav').toggle();
    });


    // Add class to hamburger when scrolled to first section
    var hamburger = $('.hamburger');
    $(window).scroll(function() {
      var scroll = $('.wrap').offset().top; // look at this
      var distance = $(window).scrollTop() + 260;

      if (scroll >= distance) {
        hamburger.removeClass('addbg');
      } else {
        hamburger.addClass('addbg');
      }
    });


    $('.nav-primary li:last-of-type a').addClass('button white');

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired


    $('.slider').slick({
      dots: false,
      vertical: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      verticalSwiping: false,
    });


    $('.facilities-slider').slick({
      infinite: true,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      rtl: true,
    });



    // Smooth scrolling
    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top,
            }, 1000, function() {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(':focus')) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            });
          }
        }
      });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js